export default __webpack_public_path__ + "static/media/head-bg-mb@2x.b581018d.jpg";